<div class="modal-header">
  @if (!alert.message) {
  <h4 class="modal-title" id="modal-title">{{title}}</h4>
  }
  <button addAaTags="Close popup" type="button" class="btn-close" aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')"
    (keydown.enter)="modal.dismiss('Cross click')"
    (keydown.space)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  @if (alert.message) {
    <ngb-alert (closed)="alert.message = ''" [type]="alert.type">{{ alert.message }}</ngb-alert>
  }
  <div [innerHTML]="message"></div>
</div>
<div class="modal-footer">
  @for (button of buttons; track button.id) {
    <app-button [type]="button.type" [disabled]="button.disabled" [class]="button.class" (click)="button.onClick()" [iconImg]="button.iconImg" [label]="button.label"></app-button>
  }
</div>
